/* tslint:disable */
/* eslint-disable */
/**
 * Employees API
 * API to get company clients employees
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeFavouriteResponse
 */
export interface EmployeeFavouriteResponse {
    /**
     * Employee ID
     * @type {number}
     * @memberof EmployeeFavouriteResponse
     */
    employeeId: number;
    /**
     * Is employee favored
     * @type {boolean}
     * @memberof EmployeeFavouriteResponse
     */
    favourite: boolean;
}

export function EmployeeFavouriteResponseFromJSON(json: any): EmployeeFavouriteResponse {
    return EmployeeFavouriteResponseFromJSONTyped(json, false);
}

export function EmployeeFavouriteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeFavouriteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'favourite': json['favourite'],
    };
}

export function EmployeeFavouriteResponseToJSON(value?: EmployeeFavouriteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'employeeId': value.employeeId,
        'favourite': value.favourite,
    };
}

